import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionlinecabbooking() {



const cardData = {
  keyword: " Pune to Mumbai Online Cab Booking  ",

headingDescription:
  "Velocity Cab offers easy and convenient Pune to Mumbai online cab booking services to make your intercity travel simple and stress‑free. With a user‑friendly online booking system, you can reserve a cab for business trips, airport transfers, family visits, or leisure journeys in just a few clicks. Our professional drivers, well‑maintained vehicles, punctual pickups, and transparent pricing ensure a comfortable ride without hidden charges. Choose from one‐way trips, round trips, or customized travel packages to suit your needs. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With 24/7 customer support and reliable service, Velocity Cab is the trusted choice for Pune to Mumbai online cab booking.",

topPlaces: [
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Bandra-Worli Sea Link. Visitors traveling with an Innova Crysta on rent in Pune can enjoy a comfortable drive to this heritage site while exploring breathtaking sea views, photography spots, and Mumbai's rich colonial history."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful urban lake surrounded by modern buildings, gardens, and cafés. Travelers renting an Innova Crysta in Pune can enjoy a comfortable road trip before spending quality time by the lakeside, boating, dining, or simply relaxing with family and friends in a scenic environment."
  },
  {
    title: "Mahalakshmi Temple",
    description: "Mahalakshmi Temple is one of Mumbai's oldest and most revered Hindu temples dedicated to Goddess Mahalakshmi. Choosing an Innova Crysta on rent in Pune ensures a comfortable journey for pilgrims and tourists visiting this sacred temple while also exploring nearby coastal viewpoints and local markets."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's most famous shopping and dining streets, offering everything from fashion accessories to local handicrafts and cafés. Travelers booking an Innova Crysta on rent in Pune can comfortably reach this vibrant destination and enjoy shopping, street food, and the lively atmosphere. It is an ideal stop for families, couples, and groups exploring South Mumbai."
  },
  {
    title: "Girgaon Chowpatty",
    description: "Girgaon Chowpatty is a popular public beach known for its festive atmosphere and delicious Mumbai street food. Renting an Innova Crysta in Pune makes the road trip comfortable for families and friends planning a relaxing day by the sea. Visitors can enjoy beautiful sunsets, local snacks like pav bhaji and bhel puri, and various cultural celebrations."
  },
  {
    title: "Nehru Planetarium",
    description: "Nehru Planetarium is an educational attraction that offers fascinating astronomy shows and interactive exhibits. Travelers choosing an Innova Crysta on rent in Pune can enjoy a hassle-free drive to this destination, making it an excellent place for students, families, and science enthusiasts interested in space exploration."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is a magnificent meditation monument located near Gorai in Mumbai. Visitors hiring an Innova Crysta on rent in Pune can comfortably travel to this peaceful destination to admire its grand golden dome, meditation halls, and serene surroundings. It is perfect for spiritual retreats and peaceful sightseeing."
  },
  {
    title: "Kanheri Caves",
    description: "Kanheri Caves are ancient Buddhist rock-cut caves situated inside Sanjay Gandhi National Park. Renting an Innova Crysta in Pune allows travelers to enjoy a smooth journey before exploring centuries-old sculptures, prayer halls, and historical carvings. The destination is ideal for history lovers, photographers, and adventure seekers."
  },
  {
    title: "Hanging Gardens",
    description: "The Hanging Gardens on Malabar Hill offer beautifully landscaped gardens with panoramic views of Marine Drive and the Arabian Sea. Travelers booking an Innova Crysta on rent in Pune can relax amidst lush greenery, enjoy peaceful walks, and capture stunning city views from one of Mumbai's most scenic locations."
  },
  
  {
    title: "Film City, Goregaon",
    description: "Film City in Goregaon is the heart of Mumbai's film and television industry. Travelers hiring an Innova Crysta on rent in Pune can comfortably visit this famous attraction, where guided tours showcase movie sets, shooting locations, lush greenery, and behind-the-scenes experiences of Bollywood filmmaking."
  }
],



services: [
{
name: "Pune to Mumbai Online Cab Booking Price",
description: "Pune to Mumbai online cab booking price services help travelers easily check and compare cab fares before confirming their ride. Online booking platforms allow passengers to select vehicles such as sedan, Ertiga, or Innova depending on their travel needs. Professional drivers ensure safe highway travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow quick and convenient ride reservations."
},
{
name: "Pune to Mumbai Return Cab Fare",
description: "Pune to Mumbai return cab fare services provide transparent pricing for travelers planning round-trip journeys between the two cities. Comfortable vehicles with professional drivers ensure safe and reliable highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business meetings, tourism visits, and family trips. Flexible booking options allow convenient round-trip cab reservations."
},
{
name: "Pune to Mumbai Taxi Fare",
description: "Pune to Mumbai taxi fare services provide clear pricing information for passengers traveling between Pune and Mumbai. Travelers can choose from sedan, SUV, and premium vehicles depending on their travel requirements. Professional drivers ensure safe driving and punctual pickup services via the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy travel planning."
},
{
name: "Pune to Mumbai Affordable Fare",
description: "Pune to Mumbai affordable fare cab service offers economical travel options for passengers looking for budget-friendly intercity transportation. Vehicles provide comfortable seating and reliable highway travel at reasonable rates. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Pune Mumbai Online Innova Booking",
description: "Pune Mumbai online Innova booking service allows travelers to reserve spacious SUV vehicles for comfortable intercity travel. Innova cars provide ample seating and luggage space suitable for family trips and corporate travel. Professional drivers ensure safe and punctual journeys along the Mumbai–Pune Expressway. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient SUV reservations."
},
{
name: "Pune Mumbai Online Ertiga Booking",
description: "Pune Mumbai online Ertiga booking service offers comfortable SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides spacious seating and luggage space suitable for family travel and airport transfers. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy online reservations."
},
{
name: "Pune to Mumbai Sedan Cab Booking Online",
description: "Pune to Mumbai sedan cab booking online service allows travelers to reserve economical sedan vehicles for expressway travel. Sedan cars provide comfortable seating and smooth ride quality suitable for business travelers and small families. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow quick online reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for passengers traveling between Pune and Mumbai. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys. Professional drivers ensure safe driving and punctual pickup services along the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient SUV ride reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service provides premium SUV transportation for comfortable long-distance travel. Innova vehicles offer spacious seating and smooth ride quality ideal for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Online Innova Crysta Booking",
description: "Pune to Mumbai online Innova Crysta booking service offers luxury SUV transportation for travelers seeking premium comfort. Innova Crysta vehicles provide spacious seating, premium interiors, and smooth highway ride quality. Professional drivers ensure punctual pickup and safe travel via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient luxury ride reservations."
},
{
name: "Toyota Innova Crysta Car Hire Pune",
description: "Toyota Innova Crysta car hire Pune service offers premium SUV rental for travelers seeking luxury transportation. The Innova Crysta provides spacious seating and smooth ride quality suitable for long-distance highway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient SUV hire reservations."
},
{
name: "Toyota Innova Ertiga Car Booking",
description: "Toyota Innova Ertiga car booking service provides comfortable SUV travel options for passengers planning intercity trips. Travelers can choose between Innova and Ertiga vehicles depending on group size and luggage needs. Professional drivers ensure safe and punctual highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow easy vehicle reservations."
},
{
name: "Pune to Mumbai Sedan Cab Service Online Booking",
description: "Pune to Mumbai sedan cab service online booking allows travelers to easily reserve economical sedan cars for comfortable highway travel. Vehicles are well maintained and suitable for expressway journeys with professional drivers ensuring safe travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow quick online reservations."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service offers convenient return transportation for travelers planning trips between the two cities. Comfortable vehicles with experienced drivers ensure safe journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, tourism visits, and family trips. Flexible booking options allow easy round-trip cab reservations."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai offers reliable and comfortable transportation along the Mumbai–Pune Expressway. Vehicles are well maintained and suitable for long-distance travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai 24x7 Online Cab Booking",
description: "Pune to Mumbai 24x7 online cab booking service provides round-the-clock transportation for travelers planning intercity trips anytime. Passengers can easily book rides online and select suitable vehicles for their journey. Professional drivers ensure safe and punctual highway travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow quick ride reservations."
},
{
name: "Pune to Mumbai Airport Cab Service",
description: "Pune to Mumbai Airport cab service offers reliable airport transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and sufficient luggage space for airport travel. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow convenient airport ride reservations."
},
{
name: "Pune Airport to Mumbai Cab",
description: "Pune Airport to Mumbai cab service provides convenient transportation for passengers arriving at Pune Airport and traveling to Mumbai. Comfortable vehicles with professional drivers ensure safe expressway travel. Pickup services are available directly from Pune Airport and nearby locations. Ideal for business travelers, tourists, and families. Flexible booking options allow easy airport cab reservations."
}
],

tableData: [
["Pune to Mumbai Online Cab Booking Price","Pune to Mumbai Return Cab Fare"],
["Pune to Mumbai Taxi Fare","Pune to Mumbai Affordable Fare"],
["Pune Mumbai Online Innova Booking","Pune Mumbai Online Ertiga Booking"],
["Pune to Mumbai Sedan Cab Booking Online","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune to Mumbai Online Innova Crysta Booking"],
["Toyota Innova Crysta Car Hire Pune","Toyota Innova Ertiga Car Booking"],
["Pune to Mumbai Sedan Cab Service Online Booking","Pune to Mumbai Cab Round Trip"],
["Best Cab Service Pune to Mumbai","Pune to Mumbai 24x7 Online Cab Booking"],
["Pune to Mumbai Airport Cab Service","Pune Airport to Mumbai Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking",
    WhyChoosedescription: "Velocity Cabs provides a simple and convenient Pune to Mumbai online cab booking system. Customers can quickly reserve their cab through phone or online booking with instant confirmation and hassle-free travel planning."
  },
  {
    WhyChooseheading: "Transparent Online Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Pune to Mumbai online cab bookings. Customers receive complete fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our Pune to Mumbai online cab booking service is available 24 hours a day. Whether you need a cab early morning, late night, or during peak travel hours, Velocity Cabs ensures reliable transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are air-conditioned, well maintained, and regularly cleaned to provide a comfortable intercity travel experience between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Booking",
    WhyChoosedescription: "Velocity Cabs offers flexible booking options including one way cab service, round trip travel, airport transfers, and customized travel plans between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and railway stations across Pune including Baner, Hinjewadi, Wakad, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Trusted Pune to Mumbai Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune to Mumbai online cab booking thanks to our punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "How can I book Pune to Mumbai cab online?", answer: "You can easily book Pune to Mumbai cab online through Velocity Cabs website or by contacting our booking team." },
  { question: "Is Pune to Mumbai online cab booking available 24 hours?", answer: "Yes, Velocity Cabs provides 24/7 online cab booking service between Pune and Mumbai." },
  { question: "Which vehicles are available for Pune to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one way cab online?", answer: "Yes, customers can easily book one way or round trip cab services online between Pune and Mumbai." },
  { question: "Do you provide pickup from homes and hotels in Pune?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and railway stations across Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long distance travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and peak travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides airport drop services to Mumbai Airport and other locations across Mumbai." },
  { question: "Do you provide corporate cab bookings?", answer: "Yes, Velocity Cabs provides cab booking services for corporate travel and business trips." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very convenient Pune to Mumbai online cab experience. The booking was simple, the cab arrived on time, and the ride felt smooth and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Mumbai online cab service was reliable and well-organized. The vehicle was clean, the driver was professional, and the journey felt safe and hassle-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Online Cab Booking | Velocity Cabs",
  "description": "Velocity Cabs offers easy and affordable Pune to Mumbai online cab booking with instant confirmation. Book sedan, Ertiga, Innova, and Innova Crysta cabs for one way, round trip, and airport transfers. Enjoy 24x7 online taxi booking with safe, reliable, and comfortable travel at the best prices.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai Online Cab Booking | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai online cab with Velocity Cabs. 24x7 taxi booking for sedan, Ertiga, Innova & Crysta. Affordable fares, instant confirmation & reliable Pune to Mumbai cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionlinecabbooking;